import { ExternalLink, Eye, FilePenLine } from "lucide-react";

export default function OrchestratorLiveStage({ artifact, onClose }) {
  if (!artifact?.previewUrl && !artifact?.publicUrl) return null;
  const isLive = artifact.type === "live_page" && artifact.publicUrl;
  const iframeSrc = isLive ? artifact.publicUrl : artifact.previewUrl;

  return (
    <div className="shrink-0 border-b border-[var(--border-default)] bg-[var(--bg-base)]">
      <div className="px-3 py-2 flex items-center justify-between gap-2 border-b border-[var(--border-default)]">
        <div className="min-w-0">
          <div className="text-[10px] font-mono uppercase tracking-widest text-[var(--text-tertiary)]">
            {isLive ? "Live preview" : "Draft preview"}
          </div>
          <div className="text-xs font-medium truncate text-[var(--text-primary)]">{artifact.label}</div>
        </div>
        <div className="flex items-center gap-1 shrink-0">
          {artifact.publicUrl ? (
            <a
              href={artifact.publicUrl}
              target="_blank"
              rel="noreferrer"
              className="h-8 px-2 inline-flex items-center gap-1 rounded-lg text-[11px] text-[var(--primary)] hover:bg-[var(--bg-elev)]"
            >
              <ExternalLink size={12} /> Live
            </a>
          ) : null}
          {artifact.adminUrl ? (
            <a
              href={artifact.adminUrl}
              className="h-8 px-2 inline-flex items-center gap-1 rounded-lg text-[11px] text-[var(--text-secondary)] hover:bg-[var(--bg-elev)]"
            >
              <FilePenLine size={12} /> Editor
            </a>
          ) : null}
          {onClose ? (
            <button
              type="button"
              className="h-8 w-8 grid place-items-center rounded-lg text-[var(--text-tertiary)] hover:bg-[var(--bg-elev)]"
              aria-label="Hide preview"
              onClick={onClose}
            >
              <Eye size={14} />
            </button>
          ) : null}
        </div>
      </div>
      <div className="h-[min(38vh,320px)] bg-[var(--bg-elev)]">
        <iframe
          title={artifact.label || "Live preview"}
          src={`${iframeSrc}${iframeSrc.includes("?") ? "&" : "?"}orch_preview=1`}
          className="w-full h-full border-0 bg-white"
          sandbox="allow-scripts allow-same-origin allow-forms"
        />
      </div>
    </div>
  );
}
